export function coverageAjax(){
    (function($) {
        let postType = 'sedi';
        function load_sedi(geo_area, country, city){
            let str ='&postType=' + postType + '&geo_area=' + geo_area + '&country=' + country + '&city=' + city + '&action=coverage_filters';
            console.log(str);
            $.ajax({
                type: "POST",
                dataType: "html",
                url: ajax_posts.ajaxurl,
                data: str,
                success: function(data){
                    let $data = $(data);
                    if($data){
                        $('#ajax_content_sedi').html($data);
                    }else{
                        $('#ajax_content_sedi').html('');
                    }
                    console.log($data);
                },
                error : function(jqXHR, textStatus, errorThrown) {
                    //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
        
            });
            return false;
        }

        function geo_change(geo_area, country, city){
            let str ='&geo_area=' + geo_area + '&country=' + country + '&city=' + city + '&action=option_geo_ajax';
            console.log(str);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_posts.ajaxurl,
                data: str,
                success: function(data){
                    console.log(data);
            
                    // Assicurati che i tuoi dati contengano le chiavi corrette (city e country)
                    if (data.city) {
                        $('#ajax_city').html(data.city);
                        $("#city_select").select2();
                    }
        
                    if (data.country) {
                        $('#ajax_country').html(data.country);
                        $("#country_select").select2();
                    }

                    $('#ajax_country_link').html('');
                },
                error : function(jqXHR, textStatus, errorThrown) {
                    //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
        
            });
            return false;
        }

        function country_change(geo_area, country, city){
            let str ='&geo_area=' + geo_area + '&country=' + country + '&city=' + city + '&action=option_country_ajax';
            console.log(str);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_posts.ajaxurl,
                data: str,
                success: function(data){
                    console.log(data);
            
                    // Assicurati che i tuoi dati contengano le chiavi corrette (city e country)
                    if (data.city) {
                        $('#ajax_city').html(data.city);
                        $("#city_select").select2();
                    }
                    if (data.geo_area) {
                        $('#ajax_geo').html(data.geo_area);
                        $("#geo_area_select").select2();
                    }
                    if(data.country_link){
                        $('#ajax_country_link').html(data.country_link);
                    }else{
                        $('#ajax_country_link').html('');
                    }
                },
                error : function(jqXHR, textStatus, errorThrown) {
                    //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
        
            });
            return false;
        }

        function city_change(geo_area, country, city){
            let str ='&geo_area=' + geo_area + '&country=' + country + '&city=' + city + '&action=option_city_ajax';
            console.log(str);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_posts.ajaxurl,
                data: str,
                success: function(data){
                    console.log(data);
            
                    if (data.city) {
                        $('#ajax_city').html(data.city);
                        $("#city_select").select2();
                    }

                    if (data.country) {
                        $('#ajax_country').html(data.country);
                        $("#country_select").select2();
                    }

                    if (data.geo_area) {
                        $('#ajax_geo').html(data.geo_area);
                        $("#geo_area_select").select2();
                    }
                },
                error : function(jqXHR, textStatus, errorThrown) {
                    //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
        
            });
            return false;
        }


        $("#city_select").on('change', function(){
            let geo_area = $('#geo_area_select').val();
            let country = $('#country_select').val();
            let city = $('#city_select').val();
            console.log(country);
            console.log('pre load sedi');
            city_change(geo_area, country, city)
            load_sedi(geo_area, country, city);
        })

        $('#country_select').on('change', function(){
            let geo_area = $('#geo_area_select').val();
            let country = $('#country_select').val();
            let city = $('#city_select').val();
            console.log(country);
            console.log('pre load city');
            country_change(geo_area, country, city)
            load_sedi(geo_area, country, city);
        })

        $("#geo_area_select").on('change', function(){
            let geo_area = $('#geo_area_select').val();
            let country = $('#country_select').val();
            let city = $('#city_select').val();
            console.log(country);
            console.log('pre load city');
            geo_change(geo_area, country, city)
            load_sedi(geo_area, '', '');
            //load_sedi(geo_area, null, null);
        })

    })(jQuery);
}